export function initializeNavigation() {
    document.addEventListener('DOMContentLoaded', function () {

        let currentDepth = 0;
        let hasSetup = false;

        function initNav() {
            if (hasSetup) return;

            setUpBackButtons();
            setUpClickHandlers();
            hasSetup = true;
        }

        const setUpClickHandlers = () => {
            let hasChild = document.querySelectorAll('.header-nav__has-child > .header-nav__link button');

            hasChild.forEach(function (item) {
                item.addEventListener('click', function (event) {
                    console.log('clicked');
                    event.preventDefault();

                    let parent = this.parentElement.parentElement;
                    let sub = parent.querySelector('.header-nav__mega-sub');

                    console.log(sub);
                    sub.classList.add('active');
                });
            });
        };

        const setUpBackButtons = () => {
            let subs = document.querySelectorAll('.header-nav__has-child ul');

            subs.forEach(function (item) {


                let back = document.createElement('li');
                back.classList.add('back');
                back.innerHTML = '<button class="back"><i class="bx bx-chevron-left"></i> Back</button>';
                item.insertBefore(back, item.firstChild);


                back.addEventListener('click', function (event) {
                    event.preventDefault();
                    this.parentElement.classList.remove('active');
                });
            });
        };

        if(window.matchMedia('(max-width: 1199px)').matches) {
            initNav();
        }
    });
}
